'use client';

import { Box, Button, Container, Grid, Typography } from '@mui/material';
import cx from 'clsx';

import { Link } from '@/i18n/navigation';
import colors from '@/styles/themes/colors';
import { SolutionColor } from '@/types/solution.type';

import AIShowcaseItem, { AISolution } from './AIShowcaseItem';
import styles from './AIShowcaseSection.module.scss';

interface AIShowcaseSectionProps {
  title: string;
  description: string;
  ctaText: string;
  ctaHref?: string;
  solutions: AISolution[];
  color?: SolutionColor;
}

const AIShowcaseSection = ({
  title,
  description,
  ctaText,
  ctaHref = '/contact',
  solutions,
  color = 'blue',
}: AIShowcaseSectionProps) => (
  <Container
    maxWidth={false}
    disableGutters
    component="section"
    className={cx(styles.section, styles[`color${color.charAt(0).toUpperCase()}${color.slice(1)}`])}
  >
    <Container maxWidth="xl" className={styles.container}>
      <Grid container columnSpacing={12} rowSpacing={8}>
        <Grid size={{ xs: 12, lg: 6 }} className={styles.stickyContainer}>
          <Typography variant="h2" color={colors.white} fontWeight={500}>
            {title}
          </Typography>
          <Typography variant="body1" color={colors.graytone200} marginTop={2}>
            {description}
          </Typography>
          <Button component={Link} href={ctaHref} variant="contained" sx={{ mt: 3 }}>
            {ctaText}
          </Button>
        </Grid>
        <Grid size={{ xs: 12, lg: 6 }}>
          <Box className={styles.solutionsList}>
            {solutions.map(solution => (
              <AIShowcaseItem key={solution.title} solution={solution} color={color} />
            ))}
          </Box>
        </Grid>
      </Grid>
    </Container>
  </Container>
);

export default AIShowcaseSection;
